/* eslint-disable react/jsx-props-no-spreading -- the server props are the component contract */
import React from 'react';
import VisitsSection from '../../Visits';
function ShowVisitsSection(props) {
    return React.createElement(VisitsSection, Object.assign({}, props));
}
export default ShowVisitsSection;
